export { PartnerGeneral as default } from "./partner-general";
